import { useMediaQuery } from '@chakra-ui/react';

const useIsMobile = (maxWidth?: string): boolean =>
  useMediaQuery(`(max-width: ${maxWidth ?? '768px'})`)[0] ?? false;

export default useIsMobile;
